/**
 * Seller en formularios: a veces se guarda un snapshot en general.generalObject (p. ej. al ir a
 * seleccionar tipos de publicación). editSeller solo actualiza sellers.seller; si el mapState
 * prefería generalObject, al volver de pestaña o pantalla se veían datos viejos.
 * El merge hace que los cambios en Redux (sellers.seller) suelen pisar al snapshot.
 *
 * Caso extra: fetchSeller() sin id deja sellers.seller como template vacío; entonces { ...go, ...s }
 * hacía que el template vacío pisara al snapshot en generalObject. Si detectamos ese borrador vacío
 * y hay datos en generalObject, volvemos a priorizar generalObject en los solapes.
 */
function trimStr(v) {
    return v == null ? '' : String(v).trim();
}

function looksLikeEmptyNewSellerDraft(s) {
    if (s == null || typeof s !== 'object') return true;
    return (
        !trimStr(s.razonSocial)
        && !trimStr(s.nombreTienda)
        && !trimStr(s.email)
        && !trimStr(s.cuit)
    );
}

function hasMeaningfulSellerSnapshot(go) {
    if (go == null || typeof go !== 'object') return false;
    return !!(trimStr(go.razonSocial) || trimStr(go.nombreTienda) || trimStr(go.email));
}

export function selectSellerMerged(state) {
    const go = state.general.generalObject;
    const s = state.sellers.seller;
    if (go == null || typeof go !== 'object' || Object.keys(go).length === 0) {
        return s;
    }
    const merged = { ...go, ...s };
    if (looksLikeEmptyNewSellerDraft(s) && hasMeaningfulSellerSnapshot(go)) {
        return { ...merged, ...go };
    }
    return merged;
}
